import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { deepEquals } from "app/tools/common"

export const canLeaveUiConfigPage = (): undefined | string => {
  const { config, tempConfig } = getStore().getState().ui
  return deepEquals(config, tempConfig) ? undefined : translate("admin.ui-configuration.page.leave")
}
